var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "40px",
    width: "40px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496.016 496.016",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    transform: "matrix(1, 0, 0, -1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.016,0C111.264,0,0.008,111.256,0.008,248.004c0,136.752,111.256,248.012,248.008,248.012 c136.744,0,247.992-111.256,247.992-248.012C496.008,111.256,384.76,0,248.016,0z M368.336,363.416 c-3.016,4.808-8.284,7.564-14.452,7.564c-3.904,0-8.26-1.104-12.944-3.284l-218.004-101.4 c-14.396-6.692-15.52-15.58-14.908-20.284c0.604-4.704,3.964-13.008,19.588-15.812l85.516-16.984l14.648-82.592 c2.82-17.884,13.188-19.84,17.516-19.84c5.108,0,12.432,2.564,18.32,14.764l103.836,215.26 C372.864,352.04,370.92,359.3,368.336,363.416z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M342.496,342.584L231.292,231.38c-1.576,1.536-3.584,2.64-5.84,3.092l-81.164,16.12l198.336,92.248L342.496,342.584z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.2044748c4e72c3dd2aa08d49cccbd47a.svg";
export { ForwardRef as ReactComponent };